import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { packageStatus } from 'common/packages';

const DeleteDialog = (props) => {
  const { open, pkg, deleting, onCancel, onConfirm } = props;

  const [confirmation, setConfirmation] = useState('');

  useEffect(() => {
    if (open) setConfirmation('');
  }, [open]);

  const matches = confirmation === pkg.name;

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>Delete {pkg.name}?</DialogTitle>
      <DialogContent>
        {pkg.is_published && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This package is {packageStatus(pkg).toLowerCase()}. Deleting it removes it
            from every client that resolves packages through the API, immediately.
          </Alert>
        )}
        <DialogContentText gutterBottom>
          The database row and the stored objects — artifact, thumbnail and icon — are
          all deleted. This cannot be undone; recovering means uploading the artifact
          again.
        </DialogContentText>
        <DialogContentText gutterBottom>
          Type <strong>{pkg.name}</strong> to confirm.
        </DialogContentText>
        <TextField
          fullWidth
          size="small"
          autoFocus
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
          placeholder={pkg.name}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={deleting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          disableElevation
          onClick={onConfirm}
          disabled={!matches || deleting}
        >
          Delete package
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteDialog.propTypes = {
  deleting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  pkg: PropTypes.object.isRequired,
};

export default DeleteDialog;
